<template>
    <basic-card>
        <template #header>
            {{ $t('accountBalances.accountBalances') }}
        </template>
        <simple-list :default-sort="defaultSort" :columns="listColumns" object-name="accountBalance"
                     query-store-name="account" :config="listConfig"/>
    </basic-card>
</template>

<script>
import BasicCard from "../components/layout/BasicCard";
import SimpleList from "../components/lists/SimpleList";
import { mapGetters } from "vuex";

export default {
    name: "AccountBalancesView",
    components: {SimpleList, BasicCard},
    computed: {
        ...mapGetters({
            "account": "banking/account"
        })
    },
    data() {
        return {
            defaultSort: {column: {}, sortField: 'balanceDate', direction: 'DESC'},
            listConfig: {
                tableConfiguration: {
                    enableCheck: true
                },
                pageSize: 150
            },
            listColumns: [
                {
                    caption: "Id",
                    datum: d => d.id
                },
                {
                    caption: this.$t('accounts.account'),
                    datum: d => this.account(d.accountId).name,
                    sortField: "accountId",
                    allowSort: true
                },
                {
                    caption: this.$t('accounts.number'),
                    datum: d => this.account(d.accountId).accountNumber,
                    sortField: "accountId",
                    allowSort: true
                },
                {
                    caption: this.$t('accounts.balanceDate'),
                    datum: d => this.$formats.formatDate(d.balanceDate, false),
                    sortField: "balanceDate",
                    allowSort: true
                },
                {
                    caption: this.$t('accountBalances.startBalance'),
                    datum: d => this.$formats.formatAmount(d.startBalance / 100),
                    exportDatum: d => d.startBalance / 100,
                    sortField: "startBalance",
                    allowSort: true
                },
                {
                    caption: this.$t('accountBalances.endBalance'),
                    datum: d => this.$formats.formatAmount(d.endBalance / 100),
                    exportDatum: d => d.endBalance / 100,
                    sortField: "endBalance",
                    allowSort: true
                }
            ]
        }
    },
}
</script>

<style lang="scss" scoped>

</style>